import AlpineCollapse from '@alpinejs/collapse';
import AlpineFocus from '@alpinejs/focus';
import AlpineMask from '@alpinejs/mask';
import Alpine from 'alpinejs';

window.Alpine = Alpine;

import { autoUpdate, computePosition, flip, shift } from '@floating-ui/dom';

document.addEventListener('alpine:init', () => {
  Alpine.data('dropdown', () => ({
    open: false,

    init() {
      this.cleanup;

      if (this.$refs.menu) {
        this.$refs.menu.addEventListener('updated', () => {
          requestAnimationFrame(() => {
            this.cleanup = autoUpdate(
              this.$refs.toggle,
              this.$refs.menu,
              this.updatePosition.bind(this),
            );
          });
        });
      }

      this.$watch('open', (isOpen) => {
        if (isOpen) {
          requestAnimationFrame(() => {
            this.cleanup = autoUpdate(
              this.$refs.toggle,
              this.$refs.menu,
              this.updatePosition.bind(this),
            );
          });
        } else {
          if (this.cleanup) {
            this.cleanup();
          }
        }
      });
    },

    updatePosition() {
      computePosition(this.$refs.toggle, this.$refs.menu, {
        placement: 'bottom-end',
        middleware: [flip(), shift()],
        strategy: 'fixed',
      }).then(({ x, y }) => {
        Object.assign(this.$refs.menu.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    },

    toggle() {
      this.open = !this.open;
    },
  }));
});

Alpine.plugin(AlpineMask);
Alpine.plugin(AlpineCollapse);
Alpine.plugin(AlpineFocus);

Alpine.start();
